export default __webpack_public_path__ + "static/media/react-original.7098e271.svg";